import Ajax from "Utils/ajax";
export const getPageList = (data) => Ajax.post('admin/getPageList',data);
export const addUpdatePage = (data) => Ajax.post('admin/addUpdatePage',data);
export const deletePage = (data) => Ajax.post('admin/deletePage',data);